import gif from "./christmas.gif";
import React, { useState, useEffect } from "react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import * as anchor from "@project-serum/anchor";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";

import { useAnchorWallet } from "@solana/wallet-adapter-react";

import {
  awaitTransactionSignatureConfirmation,
  getCandyMachineState,
  mintOneToken,
} from "./services/candy-machine";
import { useAlert } from 'react-alert'
export default function Mint(props) {
  const alert = useAlert()
  const [balance, setBalance] = useState();
  const [isActive, setIsActive] = useState(true); // true when countdown completes
  const [isSoldOut, setIsSoldOut] = useState(false); // true when items remaining is zero
  const [isMinting, setIsMinting] = useState(false); // true when user got to press MINT

  const [itemsAvailable, setItemsAvailable] = useState(0);
  const [itemsRedeemed, setItemsRedeemed] = useState(0);
  const [itemsRemaining, setItemsRemaining] = useState(0);
  const wallet = useAnchorWallet();
  const [candyMachine, setCandyMachine] = useState();
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });

  const onMint = async () => {

    try {
      setIsMinting(true);
      if(isMinting){
        alert.show("Minting has started!");
      }
      
      console.log(candyMachine.program);
      if (wallet && candyMachine.program) {
        const mintTxId = await mintOneToken(
          candyMachine,
          props.config,
          wallet.publicKey,
          props.treasury
        );

        const status = await awaitTransactionSignatureConfirmation(
          mintTxId,
          props.txTimeout,
          props.connection,
          "singleGossip",
          false
        );

        if (!status.err) {
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
          });
      
          alert.show('Congratulations! Mint succeeded!')
        } else {
          setAlertState({
            open: true,
            message: "Please check your wallet, connect wallet again if failed!",
            severity: "error",
          });
     
          alert.show('Please check your wallet, connect wallet again if failed!')
        }
      }
    } catch (error) {
      // TODO: blech:
      // alert.show('Minting failed! Try to Connect Wallet Again')
      
      let message = error.msg || "Please check your wallet, connect wallet again if failed!";
      alert.show(message);
      if (!error.msg) {
        if (error.message.indexOf("0x138")) {
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
          alert.show('SOLD OUT!')
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
          alert.show('Insufficient funds to mint. Please fund your wallet.')
          console.log(message)
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          setIsSoldOut(true);
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
          alert.show("Minting period hasn't started yet.")
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
      setIsMinting(false);
      refreshCandyMachineState();
    }

  };

  const refreshCandyMachineState = () => {
    (async () => {
      if (!wallet) return;

      const {
        candyMachine,
        goLiveDate,
        itemsAvailable,
        itemsRemaining,
        itemsRedeemed,
      } = await getCandyMachineState(
        wallet,
        props.candyMachineId,
        props.connection
      );
      console.log("IA", itemsAvailable);
      console.log("IR", itemsRemaining);
      console.log("IReddemed", itemsRedeemed);
      console.log("Go LIVE Date", goLiveDate);
      setItemsAvailable(itemsAvailable);
      setItemsRemaining(itemsRemaining);
      setItemsRedeemed(itemsRedeemed);
      setCandyMachine(candyMachine);
      console.log(isActive);

      setIsSoldOut(itemsRemaining === 0);
    })();
  };

  useEffect(() => {
    (async () => {
      if (wallet) {
        const balance = await props.connection.getBalance(wallet.publicKey);
        setBalance(balance / LAMPORTS_PER_SOL);
      }
    })();
  }, [wallet, props.connection]);

  useEffect(refreshCandyMachineState, [
    wallet,
    props.candyMachineId,
    props.connection,
  ]);
  return (
    <>
      <div className="topcorner">
        <WalletMultiButton />
      </div>

      <div className="center">
        <div>
          <img src={gif} alt="" />
        </div>
        <div>
          <button
            className="btn"
            disabled={isSoldOut || isMinting || !isActive}
            onClick={onMint}
          >
            {isSoldOut
              ? "SOLD OUT"
              : isActive
              ? isMinting
                ? "Minting"
                : "MINT NOW"
              : "Count Down"}
          </button>
        </div>
        <div></div>
      </div>
    </>
  );
}
